import { forwardRef, type SVGAttributes } from 'react';

const LibrasIcon = forwardRef<SVGSVGElement, SVGAttributes<SVGSVGElement>>(
  ({ className, fill = 'white', ...props }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill={fill}
        className={className}
        {...props}
      >
        <g clipPath="url(#a)">
          <path
            fill={fill}
            d="M15.701 6.888c.332.137.283.38.285.622.006.531.01 1.063 0 1.595-.01.577.203 1.23-.736 1.42-.337.069-.451.468-.438.855.029.875.007 1.751.01 2.627.001.37-.055.728-.53.746-.525.02-.632-.355-.635-.763-.006-.834-.002-1.667-.171-2.545-.478 1.066-.951 2.134-1.434 3.197-.168.37-.331.854-.886.638-.611-.238-.349-.704-.17-1.11.285-.65.572-1.299.735-2.06-.883.607-1.765 1.217-2.652 1.818-.353.24-.757.517-1.084.02-.27-.41.038-.68.389-.914.692-.461 1.368-.944 2.085-1.545-1.218.237-1.938-.495-2.728-1.1-.405-.312-.553-.632-.236-1.03l.065-.075c.573-.16.93.207 1.262.53.631.618 1.392.594 2.172.468.648-.104.934-.529.897-1.14-.034-.578-.38-.89-.97-1-.569-.106-.996.118-1.416.449-.418.33-.828.727-1.437.57l-.116-.035c-.042-.782 1.204-2.465 1.997-2.76 2.01-.744 3.884-.245 5.742.522ZM4.834.72c.611.238.349.704.17 1.11-.286.65-.572 1.299-.735 2.06.883-.607 1.765-1.217 2.652-1.818.353-.24.757-.517 1.084-.02.27.41-.038.681-.389.915-.692.46-1.368.943-2.084 1.544 1.217-.237 1.937.495 2.727 1.101.405.311.553.63.236 1.029l-.065.075c-.573.16-.93-.207-1.262-.53-.631-.618-1.392-.593-2.172-.468-.648.104-.933.53-.897 1.14.034.578.38.89.97 1 .569.106.996-.118 1.416-.449.418-.33.828-.727 1.437-.57l.116.035c.042.782-1.204 2.465-1.997 2.76-2.01.744-3.884.245-5.742-.522-.332-.137-.283-.38-.286-.621a55.107 55.107 0 0 1 0-1.595c.012-.578-.202-1.231.737-1.421.337-.069.451-.468.438-.855-.029-.875-.007-1.751-.01-2.627-.001-.37.055-.728.53-.746.525-.02.632.355.635.764.006.833.002 1.666.171 2.544.478-1.066.951-2.134 1.434-3.197.169-.37.331-.854.886-.638Z"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill={fill} d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

LibrasIcon.displayName = 'LibrasIcon';
export default LibrasIcon;
